import { memo, useMemo } from "react";
import { useOnlyFansCreators } from "@/common/hooks/useOnlyFansCreators";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { FeedModuleTypeEnum } from "@/common/services/types";
import { AdCreators } from "../AdCreators";
import { FeedModuleContainer } from "@/components/player-feed/FeedModules/FeedModuleContainer";
import type { IAdCreator } from "../AdCreator";

interface IOnlyFansCreatorsModule {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const OnlyFansCreatorsModule = memo(({ moduleId, moduleType }: IOnlyFansCreatorsModule) => {
  const isMobile = useDeviceType() !== deviceTypeEnum.DESKTOP;

  const { adCreators } = useOnlyFansCreators("module", 4, isMobile);
  const creators: IAdCreator[] = useMemo(
    () =>
      adCreators.map((adCreator) => ({
        name: adCreator.extra.name,
        link: adCreator.link,
        image: adCreator.extra.imgUrl,
      })),
    [adCreators]
  );

  if (!isMobile || !creators.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <AdCreators title="OnlyFans creators you might enjoy:" creators={creators} />
    </FeedModuleContainer>
  );
});
